import axios from 'axios';
import config from '../config';

const axiosInstance = axios.create({
  baseURL: `${config.apiUrl}/api`,
});

let clerkTokenGetter = null;

export const setClerkTokenGetter = (getter) => {
  clerkTokenGetter = getter;
};

axiosInstance.interceptors.request.use(
  async (requestConfig) => {
    if (clerkTokenGetter) {
      const token = await clerkTokenGetter();
      if (token) {
        requestConfig.headers.Authorization = `Bearer ${token}`;
      }
    }
    return requestConfig;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
